import type { LibraryBlock } from "../build";
import {
  BLACK_GLASS,
  CARD_SHADOW,
  ellipse,
  icon,
  iconPill,
  motion,
  pill,
  rect,
  shape,
  text,
  WHITE,
} from "./helpers";

export const CALLS: LibraryBlock[] = [
  {
    id: "cta-folgen",
    title: "Folgen",
    category: "aufruf",
    width: 520,
    height: 120,
    anchor: "bottom",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 520,
        h: 120,
        fill: "primary",
        radius: "full",
        name: "Knopf",
        shadow: { color: "#00000040", y: 10, blur: 30 },
        ...motion("pop", { loop: "pulse" }),
      }),
      ellipse({
        x: 14,
        y: 14,
        w: 92,
        h: 92,
        fill: "on:primary",
        name: "Kreis",
        ...motion("pop", { loop: "pulse" }),
      }),
      text({
        text: "+",
        style: "heading-1",
        size: 72,
        color: "primary",
        x: 14,
        y: 14,
        w: 92,
        h: 86,
        align: "center",
        ...motion("pop", { loop: "pulse" }),
      }),
      text({
        text: "Folgen für mehr",
        style: "subline",
        size: 44,
        color: "on:primary",
        x: 130,
        y: 0,
        w: 360,
        h: 120,
        align: "center",
        ...motion("pop", { loop: "pulse" }),
      }),
    ],
  },
  {
    id: "cta-link-bio",
    title: "Link in der Bio",
    category: "aufruf",
    width: 560,
    height: 220,
    anchor: "bottom",
    duration: 4000,
    nodes: [
      ...pill(
        0,
        0,
        560,
        110,
        "Link in der Bio",
        "accent",
        44,
        motion("slide-up", { loop: "float" }),
      ),
      shape("triangle", {
        x: 245,
        y: 140,
        w: 70,
        h: 60,
        fill: "accent",
        rotation: 180,
        name: "Pfeil",
        ...motion("drop", { delay: 300, loop: "float" }),
      }),
    ],
  },
  {
    id: "cta-kommentar",
    title: "Kommentieren",
    category: "aufruf",
    width: 820,
    height: 260,
    anchor: "bottom",
    duration: 4500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 820,
        h: 210,
        fill: "background",
        radius: "lg",
        name: "Sprechblase",
        shadow: { color: "#00000033", y: 10, blur: 30 },
        ...motion("pop"),
      }),
      shape("triangle", {
        x: 90,
        y: 196,
        w: 80,
        h: 60,
        fill: "background",
        rotation: 180,
        name: "Spitze",
        ...motion("pop"),
      }),
      text({
        text: "Was meinst du? Schreib es in die Kommentare!",
        style: "heading-2",
        size: 50,
        color: "text",
        x: 44,
        y: 0,
        w: 732,
        h: 210,
        align: "center",
        ...motion("fade", { delay: 250 }),
      }),
    ],
  },
  {
    id: "cta-speichern",
    title: "Speichern",
    category: "aufruf",
    width: 600,
    height: 130,
    anchor: "bottom",
    duration: 4000,
    nodes: [
      ...pill(
        0,
        0,
        600,
        130,
        "Speicher dir das!",
        "secondary",
        48,
        motion("spin", { loop: "wiggle" }),
      ),
    ],
  },
  {
    id: "cta-website",
    title: "Website",
    category: "aufruf",
    width: 800,
    height: 230,
    anchor: "bottom",
    duration: 4500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 800,
        h: 230,
        fill: "background/95",
        radius: "md",
        name: "Karte",
        ...motion("slide-up"),
      }),
      text({
        text: "Mehr erfährst du auf",
        style: "subline",
        size: 34,
        color: "text-muted",
        x: 50,
        y: 42,
        w: 700,
        align: "center",
        ...motion("fade", { delay: 200 }),
      }),
      text({
        text: "deine-seite.de",
        style: "heading-1",
        size: 76,
        color: "primary",
        x: 50,
        y: 100,
        w: 700,
        align: "center",
        ...motion("zoom", { delay: 320 }),
      }),
    ],
  },
  {
    id: "cta-wischen",
    title: "Weiter wischen",
    category: "aufruf",
    width: 520,
    height: 110,
    anchor: "bottom-right",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 520,
        h: 110,
        fill: "#000000b3",
        radius: "full",
        name: "Pille",
        ...motion("slide-left"),
      }),
      text({
        text: "Weiter wischen",
        style: "subline",
        size: 40,
        color: WHITE,
        x: 40,
        y: 0,
        w: 340,
        h: 110,
        ...motion("slide-left", { delay: 100 }),
      }),
      shape("triangle", {
        x: 410,
        y: 25,
        w: 70,
        h: 60,
        fill: "accent",
        rotation: 90,
        name: "Pfeil",
        ...motion("fly-left", { delay: 200, loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "cta-jetzt-buchen",
    title: "Jetzt buchen",
    category: "aufruf",
    width: 680,
    height: 150,
    anchor: "bottom",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 680,
        h: 150,
        fill: "accent",
        radius: "md",
        name: "Knopf",
        shadow: { color: "#00000040", y: 14, blur: 34 },
        ...motion("drop", { duration: 800, loop: "pulse" }),
      }),
      text({
        text: "Jetzt Termin sichern",
        style: "heading-2",
        size: 54,
        color: "on:accent",
        x: 40,
        y: 0,
        w: 600,
        h: 150,
        align: "center",
        ...motion("drop", { duration: 800, loop: "pulse" }),
      }),
    ],
  },
  {
    id: "cta-shop",
    title: "Zum Shop",
    category: "aufruf",
    tags: ["Shop", "kaufen", "Warenkorb", "bestellen", "Onlineshop"],
    width: 640,
    height: 130,
    anchor: "bottom",
    duration: 4000,
    nodes: iconPill(0, 0, 640, 130, {
      icon: "shopping-cart",
      label: "Jetzt shoppen",
      fill: "accent",
      badge: "background",
      iconColor: "accent",
      size: 48,
      style: "heading-2",
      move: motion("pop", { loop: "pulse" }),
    }),
  },
  {
    id: "cta-rabattcode",
    title: "Rabattcode",
    category: "aufruf",
    tags: ["Gutschein", "Code", "Rabatt", "Coupon", "Influencer", "sparen"],
    width: 820,
    height: 330,
    anchor: "center",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 820,
        h: 330,
        fill: "background",
        stroke: { color: "primary", width: 6, dash: "dashed" },
        radius: "lg",
        name: "Gutschein",
        ...motion("pop"),
      }),
      text({
        text: "Dein Rabattcode",
        style: "subline",
        size: 34,
        color: "text-muted",
        x: 40,
        y: 40,
        w: 740,
        align: "center",
        ...motion("fade", { delay: 150 }),
      }),
      rect({
        x: 150,
        y: 100,
        w: 520,
        h: 120,
        fill: "surface",
        radius: "md",
        name: "Code-Feld",
        ...motion("zoom", { delay: 250 }),
      }),
      text({
        text: "SOMMER20",
        style: "heading-1",
        size: 76,
        color: "primary",
        x: 170,
        y: 100,
        w: 480,
        h: 120,
        align: "center",
        ...motion("zoom", { delay: 300 }),
      }),
      text({
        text: "10 % auf deine erste Bestellung",
        style: "body",
        size: 32,
        color: "text",
        x: 40,
        y: 250,
        w: 740,
        align: "center",
        ...motion("fade", { delay: 500 }),
      }),
    ],
  },
  {
    id: "cta-newsletter",
    title: "Newsletter",
    category: "aufruf",
    tags: ["E-Mail", "abonnieren", "Mail", "Anmeldung", "Updates"],
    width: 780,
    height: 200,
    anchor: "bottom",
    duration: 4500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 780,
        h: 200,
        fill: "background/95",
        radius: "lg",
        name: "Karte",
        ...motion("slide-up"),
      }),
      ellipse({
        x: 40,
        y: 40,
        w: 120,
        h: 120,
        fill: "primary",
        name: "Kreis",
        ...motion("pop", { delay: 150 }),
      }),
      icon({
        icon: "envelope",
        x: 70,
        y: 70,
        w: 60,
        h: 60,
        color: "on:primary",
        name: "Brief",
        ...motion("pop", { delay: 150, loop: "wiggle" }),
      }),
      text({
        text: "Nichts mehr verpassen",
        style: "heading-2",
        size: 44,
        color: "text",
        x: 190,
        y: 42,
        w: 550,
        ...motion("slide-left", { delay: 250 }),
      }),
      text({
        text: "Jetzt Newsletter abonnieren",
        style: "subline",
        size: 30,
        color: "primary",
        x: 190,
        y: 112,
        w: 550,
        ...motion("slide-left", { delay: 350 }),
      }),
    ],
  },
  {
    id: "cta-anrufen",
    title: "Jetzt anrufen",
    category: "aufruf",
    tags: ["Telefon", "Anruf", "Nummer", "Kontakt", "Hotline"],
    width: 700,
    height: 130,
    anchor: "bottom",
    duration: 4500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 700,
        h: 130,
        fill: "accent",
        radius: "full",
        shadow: CARD_SHADOW,
        name: "Knopf",
        ...motion("pop"),
      }),
      ellipse({
        x: 15,
        y: 15,
        w: 100,
        h: 100,
        fill: "background",
        name: "Kreis",
        ...motion("pop"),
      }),
      icon({
        icon: "phone",
        x: 40,
        y: 40,
        w: 50,
        h: 50,
        color: "accent",
        name: "Telefon",
        ...motion("pop", { loop: "wiggle" }),
      }),
      text({
        text: "Jetzt anrufen",
        style: "caption",
        size: 26,
        color: "on:accent/80",
        x: 140,
        y: 14,
        w: 520,
        h: 40,
        ...motion("fade", { delay: 200 }),
      }),
      text({
        text: "0341 123 456 78",
        style: "heading-2",
        size: 46,
        color: "on:accent",
        x: 140,
        y: 52,
        w: 520,
        h: 64,
        ...motion("slide-left", { delay: 250 }),
      }),
    ],
  },
  {
    id: "cta-ganzes-video",
    title: "Ganzes Video",
    category: "aufruf",
    tags: ["YouTube", "Langversion", "ganzes Video", "Play", "anschauen"],
    width: 800,
    height: 130,
    anchor: "bottom",
    duration: 4500,
    nodes: iconPill(0, 0, 800, 130, {
      icon: "play",
      label: "Ganzes Video auf YouTube",
      fill: BLACK_GLASS,
      color: WHITE,
      badge: "primary",
      size: 40,
      move: motion("slide-up"),
      iconMove: motion("pop", { delay: 200, loop: "pulse" }),
    }),
  },
];
